  <div class="d-flex flex-column h-100">
    <div class="modal-header brder-bottom d-block p-0">
      <div class="m-4">
        <div class="row">
          <div class="col-10">
            <div class="row">
              <span class="col-4 form-input">
                <select
                  class="input-field cursor-pointer responive-min-width"
                  (change)="eventsessionList($event.target.value)">
                  <option
                    *ngFor="let days of dayList; let idx = index"
                    value="{{ days?.program_id }}"
                    [selected]="selected_index == idx"
                  >
                    {{ days?.program_name }}
                  </option>
                </select>
              </span>

              <span *ngIf="total_session != 0" class="col-8 pt-2">
                <span *ngIf="is_show_session_media == false" class="heading-3 text-margin">
                  {{ total_session }}
                  {{ mls?.languageText?.event_session_modal?.key1}}
                  <span *ngIf="mls?.is_lskey_display == 1">
                    (event_session_modal.key1)</span>
                </span>  
              </span>
            </div>
          </div>
          <div class="col-2 text-right">
            <span class="cursor-pointer" (click)="goback()">
              <img src="assets/themes/icons/cancel.svg" alt="close" />
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-body h-100">
      <div class="text-center">
        <img
          *ngIf="finished == true"
          class="text-center"
          src="assets/themes/images/primary-loader.gif"
          width="40px"
          height="40px"
          id="loadmore_post"/>
      </div>

      <div *ngIf="is_show_session_media == false">
        <div
          class="clearfix p-3 position-relative brder cursor-pointer b-radius  mb-3"
          *ngFor="let sessionCard of SessionObj">
          <img
            (click)="navigateToDetail(sessionCard?.program_id)"
            class="clndr-img float-left mr-2 mb-2"
            src="{{ sessionCard?.session_banner_list[0].file_url }}"
            onerror="this.src='assets/themes/icons/banner-placeholder.svg'"/>
          <div class="float-left calc-95 responsive-width">
            <p class="pb-3"
              (click)="navigateToDetail(sessionCard?.program_id)"
              *ngIf="action == ''">
              <span
                *ngIf="sessionCard?.credit != ''"
                class="mr-2 bg-white chip small  outline info icon-position-left">
                <img src="assets/themes/icons/cme-points.svg" alt="cme" />
                {{ sessionCard?.credit }} {{ sessionCard?.point_name }}
              </span>
              <span
                class="small chip  outline"
                *ngIf="sessionCard?.tag_name != ''">
                <span class="color-grey-700">
                  {{ sessionCard?.tag_name}}
                </span>
              </span>
            </p>
            <span (click)="navigateToDetail(sessionCard?.program_id)">
              <p class="mb-2 heading-4">{{ sessionCard?.program_name }}</p>
              <p
                (click)="navigateToDetail(sessionCard?.program_id)"
                class="paragraph  mb-2">
                <span class="color-grey-700">
                {{
                  sessionCard?.session_date_list[0].start_time
                    | getDateTimeOnTimezone
                      : sessionCard?.session_date_list[0]?.time_zone
                      : "DWT"
                }}</span>
                -
                {{
                  sessionCard?.session_date_list[0].end_time
                    | getDateTimeOnTimezone
                      : sessionCard?.session_date_list[0]?.time_zone
                      : "DWT"
                }}
                ({{ sessionCard?.session_date_list[0]?.time_zone }})
              </p>
            </span>
            <p
              class="secondary-paragraph  mt-2"
              *ngIf="sessionCard?.is_certificate == 1"
              (click)="eventcertificate(sessionCard?.program_id)">
             <u>View Certificate</u>
              <img class="pl-2" src="assets/themes/icons/right-arrow.svg" alt="right-arrow" />
            </p>

            <p
              (click)="navigateToDetail(sessionCard?.program_id)"
              *ngIf="action != ''"
              class="secondary-paragraph">
              Total media<span class="color-grey-500">
                {{ sessionCard?.total_session_media }}</span>
            </p>
          </div>       
           <span class="position-absolute arrow-position">
            <img class="pr-3" width="24px" height="24px" src="assets/themes/icons/right-arrow.svg" alt="arrow" />
           </span>
        </div>
      </div>
      <div *ngIf="is_show_session_media == true">
        <app-media-gallery [mediaData]="session_media_list"></app-media-gallery>
      </div>
    </div>
  </div>

  <app-event-view-certificate  
    *ngIf="vaultObj != null && vaultObj != undefined && isSkpModalShown == true"
    (resetSkpModal)="resetSkpModal($event)"
    [vaultObj]="vaultObj"
  ></app-event-view-certificate>